export default __webpack_public_path__ + "static/media/rocket_anim_72.3127620d.png";